import i18next from 'shared/i18n/i18next';

const INTL_LOCALE: Record<string, string> = { sv: 'sv-SE', en: 'en-US' };
const activeIntlLocale = () => INTL_LOCALE[i18next.language] ?? 'sv-SE';

type DateFormatOptions = {
  year?: Intl.DateTimeFormatOptions['year'];
  month?: Intl.DateTimeFormatOptions['month'];
  day?: Intl.DateTimeFormatOptions['day'];
  hour?: Intl.DateTimeFormatOptions['hour'];
  minute?: Intl.DateTimeFormatOptions['minute'];
  second?: Intl.DateTimeFormatOptions['second'];
  withTime?: boolean;
  locale?: string;
};

export const formatDate = (date: string | number | Date = '', options: DateFormatOptions = {}): string => {
  const defaultOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    withTime: true,
  } as const;

  const opts = { ...defaultOptions, ...options };
  const locale = options.locale ?? activeIntlLocale();

  const formatOptions: Intl.DateTimeFormatOptions = { year: opts.year, month: opts.month, day: opts.day };

  if (opts.withTime) {
    Object.assign(formatOptions, { hour: opts.hour, minute: opts.minute, second: opts.second });
  }

  return new Intl.DateTimeFormat(locale, formatOptions).format(new Date(date));
};
